import z from 'zod';

export const serviceBrands = [
  'patientrewardshub',
  'hubbux',
  'culturello',
] as const;
export const serviceBrandSchema = z.enum(serviceBrands);
export type ServiceBrand = z.infer<typeof serviceBrandSchema>;

export const serviceBrandDescription = {
  patientrewardshub: 'Patient Reward Hub',
  hubbux: 'Hubbux',
  culturello: 'Culturello',
} satisfies Record<ServiceBrand, string>;

/**
 * Given a hostname from a URL, get the corresponding ServiceBrand.
 * Fallback to `patientrewardshub` for unknown hosts.
 */
export const resolveServiceBrandFromHostname = (
  hostname: string,
): ServiceBrand => {
  const host = hostname.replace(/.*?\.(.*?)\..*/, '$1') as
    | 'patientrewardshub'
    | 'hubbux'
    | 'culturello';
  const hostToServiceBrand = {
    patientrewardshub: 'patientrewardshub',
    hubbux: 'hubbux',
    culturello: 'culturello',
  } as const;

  return hostToServiceBrand[host] || 'patientrewardshub';
};

/**
 * If window exists, resolves the ServiceBrand from the hostname given by window.location.hostname
 * Otherwise, falls back to `ServiceBrand.patientrewardshub`.
 */
export const inferServiceBrandFromWindow = () =>
  typeof window === 'undefined'
    ? 'patientrewardshub'
    : resolveServiceBrandFromHostname(window.location.hostname);
